import React from 'react'
import Svg from './Svg'
export const SvgEnter = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M8.315 12.008H.922V9.05h7.393V6.092l4.437 4.437-4.437 4.437zM23.104.177v19.224l-8.873 4.437v-4.437H5.359v-5.914h1.479v4.435h7.393V4.614l5.915-2.958H6.838v5.915H5.359V.177z" />
  </Svg>
))
SvgEnter.isIcon = true
export default SvgEnter
